module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tools/modals/message1-modal/message1-modal.component.scss
// module id = ./src/app/components/tools/modals/message1-modal/message1-modal.component.scss
// module chunks = main